export default __webpack_public_path__ + "static/media/hot-4.2fe73920.png";